import { Injectable } from '@angular/core';
import { ApiService, UserService } from 'app/services';
@Injectable()
export class BaoCaoLoDuongDayService {
  APIURL = "api/Permission";

  constructor(private api: ApiService, private user: UserService) { }

  getBaoCaoLoDuongDay(danhmucid, tungay, denngay,gio) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_BAOCAOLODUONGDAY.P_GET_BAOCAO_LODUONGDAY" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_tungay: tungay,
        v_denngay: denngay,
        v_gio: gio
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }
  getBaoCaoLoDuongDay_EXCEL(data: string, title: string, filename: string, tungay: string, denngay: string) {
    let cols = [];
  
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "time", "label": "Thời điểm", "horizontalalignment": "left" },       
        { "name": "ua", "label": "UA (V)", "horizontalalignment": "right" },
        { "name": "ub", "label": "UB (V)", "horizontalalignment": "right" },
        { "name": "uc", "label": "UC (V)", "horizontalalignment": "right" },
        { "name": "ia", "label": "IA (A)", "horizontalalignment": "right" },
        { "name": "ib", "label": "IB (A)", "horizontalalignment": "right" },
        { "name": "ic", "label": "IC (A)", "horizontalalignment": "right" },   
        { "name": "pa", "label": "PA (kW)", "horizontalalignment": "right" },
        { "name": "pb", "label": "PB (kW)", "horizontalalignment": "right" },
        { "name": "pc", "label": "PC (kW)", "horizontalalignment": "right" },
       
      ]
   
   
    var param = {
      config: "",
      para: "",
      title: title,
      header: "Từ ngày: " + tungay + " - Đến ngày: " + denngay,
      filename: "Filename",
      sheets: "Thông số vận hành",
      columns: cols,
      data: JSON.stringify(data)
    };

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/bao-cao-lo-duong-day/bao-cao-lo-duong-day.service.ts